import { render, staticRenderFns } from "./how-it-work.vue?vue&type=template&id=2bfb5a52&scoped=true"
import script from "./how-it-work.vue?vue&type=script&lang=js"
export * from "./how-it-work.vue?vue&type=script&lang=js"
import style0 from "./how-it-work.vue?vue&type=style&index=0&id=2bfb5a52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfb5a52",
  null
  
)

export default component.exports